import{a as e}from"./chunk-RAAYCPUM.js";function i(...r){return e(o,r)}function o(r,n){let t=Math.max(Math.min(n<0?r.length+n:n,r.length),0);return[r.slice(0,t),r.slice(t)]}export{i as a};
